import TabModelModule from "./tabber";

export default {
    __init__: [ 'tabModel' ],
    tabModel: [ 'type', TabModelModule ]
};